<script setup lang="ts">
import UserCard from '@/components/common/ui/UserCard.vue'
import { storeToRefs } from 'pinia'
import { usePartnerAttributionStore } from '@/stores/usePartnerAttributionStore'
import { titleCaseWord } from '@/utils/textUtils'

const partnerAttributionStore = usePartnerAttributionStore()
const { partnerAttributions, loading } = storeToRefs(partnerAttributionStore)
</script>

<template>
  <h3><b>Attribution commerciale</b></h3>
  <div v-if="partnerAttributions && !loading" class="mb-5 w-2/3">
    <table class="table">
      <thead>
        <tr>
          <th>Catégorie</th>
          <th>Filiale</th>
          <th>Commercial</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="partnerAttribution in partnerAttributions" :key="partnerAttribution.category">
          <td>
            <b>{{ titleCaseWord(partnerAttribution.category) }}</b>
          </td>
          <td>
            <img
              v-if="partnerAttribution.relatedCompany.logo"
              :src="'data:image/png;base64, ' + partnerAttribution.relatedCompany.logo"
              :alt="'logo société' + partnerAttribution.relatedCompany.name"
              class="h-12 w-12 rounded-full"
            />
            <p v-else>{{ partnerAttribution.relatedCompany.name }}</p>
          </td>
          <td>
            <user-card
              v-if="partnerAttribution.salesperson.email"
              :email="partnerAttribution.salesperson.email"
              :name="partnerAttribution.salesperson.name"
            ></user-card>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else class="w-2/3">
    <table class="table">
      <thead>
        <tr>
          <th>Catégorie</th>
          <th>Filiale</th>
          <th>Commercial</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-28"></div></td>
        </tr>
        <tr>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-28"></div></td>
        </tr>
        <tr>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-8/10 skeleton"></div></td>
          <td><div class="h-12 w-28"></div></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
